import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface PanelProps {
  children: ReactNode;
  className?: string;
  padding?: 'sm' | 'md' | 'lg';
  title?: string;
  icon?: ReactNode;
}

const paddingMap = {
  sm: 'p-4',
  md: 'p-5 sm:p-6',
  lg: 'p-6 sm:p-8',
};

export function Panel({ children, className, padding = 'md', title, icon }: PanelProps) {
  return (
    <section className={cn('panel', paddingMap[padding], className)}>
      {(title || icon) && (
        <header className="mb-4 flex items-center gap-2">
          {icon}
          {title && <h3 className="font-display text-base font-bold text-surface-950">{title}</h3>}
        </header>
      )}
      {children}
    </section>
  );
}
